import { render, staticRenderFns } from "./DevicePermissionsCard.vue?vue&type=template&id=6fa62866"
import script from "./DevicePermissionsCard.vue?vue&type=script&lang=js"
export * from "./DevicePermissionsCard.vue?vue&type=script&lang=js"
import style0 from "./DevicePermissionsCard.vue?vue&type=style&index=0&id=6fa62866&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports